import styled, { css } from 'styled-components';
import { UiColors } from 'assets/styles/old/global';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
`;

/* One row = one card. `revisit` mirrors the desktop <Tr> highlight (left accent + pink fill). */
export const Card = styled.div`
  border: 1px solid ${UiColors.strokeColor};
  border-radius: 10px;
  overflow: hidden;
  background: ${UiColors.fillWhiteColor};

  ${({ revisit }) =>
    revisit &&
    css`
      background: #fdecec;
      box-shadow: inset 3px 0 0 ${UiColors.errorColor};
    `}
`;

/* Header strip for the unlabeled columns (selection checkbox / row actions). */
export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  background: ${UiColors.cloudColor};
  border-bottom: 1px solid ${UiColors.strokeColor};
`;

export const Action = styled.div`
  display: flex;
  align-items: center;
`;

export const Field = styled.div`
  display: flex;
  align-items: ${({ block }) => (block ? 'stretch' : 'baseline')};
  flex-direction: ${({ block }) => (block ? 'column' : 'row')};
  gap: ${({ block }) => (block ? '6px' : '12px')};
  padding: 10px 12px;

  &:not(:last-child) {
    border-bottom: 1px solid ${UiColors.strokeColor};
  }
`;

export const Label = styled.span`
  flex: 0 0 38%;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${UiColors.dimGreyFillColor};
`;

export const Value = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  font-size: 14px;
  color: ${UiColors.forestColor};
  text-align: ${({ block }) => (block ? 'left' : 'right')};
  overflow-wrap: anywhere;
`;

export const Empty = styled.div`
  padding: 48px 16px;
  text-align: center;
  color: ${UiColors.dimGreyFillColor};
  font-size: 14px;
`;
